/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_EditorialInputs */

const en_val_editorial = /** @type {(inputs: Val_EditorialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editorial`)
};

const es_val_editorial = /** @type {(inputs: Val_EditorialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editorial`)
};

const fr_val_editorial = /** @type {(inputs: Val_EditorialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Éditorial`)
};

const de_val_editorial = /** @type {(inputs: Val_EditorialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redaktionell`)
};

const ja_val_editorial = /** @type {(inputs: Val_EditorialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エディトリアル`)
};

const zh_val_editorial = /** @type {(inputs: Val_EditorialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`社论式`)
};

const ar_val_editorial = /** @type {(inputs: Val_EditorialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحريري`)
};

const id_val_editorial = /** @type {(inputs: Val_EditorialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editorial`)
};

const it_val_editorial = /** @type {(inputs: Val_EditorialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editoriale`)
};

const ru_val_editorial = /** @type {(inputs: Val_EditorialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Редакционная`)
};

const pt_val_editorial = /** @type {(inputs: Val_EditorialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editorial`)
};

const ko_val_editorial = /** @type {(inputs: Val_EditorialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`에디토리얼`)
};

/**
* | output |
* | --- |
* | "Editorial" |
*
* @param {Val_EditorialInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_editorial = /** @type {((inputs?: Val_EditorialInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_EditorialInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_editorial(inputs)
	if (locale === "es") return es_val_editorial(inputs)
	if (locale === "fr") return fr_val_editorial(inputs)
	if (locale === "de") return de_val_editorial(inputs)
	if (locale === "ja") return ja_val_editorial(inputs)
	if (locale === "zh") return zh_val_editorial(inputs)
	if (locale === "ar") return ar_val_editorial(inputs)
	if (locale === "id") return id_val_editorial(inputs)
	if (locale === "it") return it_val_editorial(inputs)
	if (locale === "ru") return ru_val_editorial(inputs)
	if (locale === "pt") return pt_val_editorial(inputs)
	return ko_val_editorial(inputs)
});